import React, { Component } from 'react';
import Scroll from 'react-scroll';
import './Header.css';

const Link = Scroll.Link;
class Header extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {collapsed : 'collapse'};

        this.toggle = this.toggle.bind(this);
    }

    toggle()
    {
      this.setState({collapsed : this.state.collapsed === "" ? "collapse" : ""})
    }
    render()
    {
        return (
          <nav className="navbar bg-black" id="Header">
            <div className="container-fluid">
              <div className="navbar-header">
                <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar" onClick={this.toggle}>
                  <span className="sr-only">Toggle navigation</span>
                  <span className="icon-bar bg-white"></span>
                  <span className="icon-bar bg-white"></span>
                  <span className="icon-bar bg-white"></span>
                </button>
                <a className="navbar-brand" href="/">12BROLS</a>
              </div>
              <div className={this.state.collapsed + " navbar-collapse"} aria-expanded="false">
                <ul className="nav navbar-nav navbar-right">
                  <li><Link activeClass="active" to="BlockAbout" spy={false} smooth={true} duration={500}>About Us</Link></li>
                  <li><Link activeClass="active" to="BlockServices" spy={false} smooth={true} duration={500}>Services</Link></li>
                  <li><Link activeClass="active" to="BlockContacts" spy={false} smooth={true} duration={500}>Contacts</Link></li>
                </ul>
              </div>
            </div>
          </nav>

        )
    }
}
export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js